import { Component, useState } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var copyToClipboard = function copyToClipboard(content) {
  var textArea = document.createElement('textarea');
  textArea.style.maxHeight = '0px';
  textArea.style.height = '0px';
  textArea.style.opacity = '0';
  textArea.value = content;
  document.body.appendChild(textArea);
  textArea.select();
  window.document.execCommand('copy');
  document.body.removeChild(textArea);
};

var CopyToClipboard =
/** @class */
function (_super) {
  __extends(CopyToClipboard, _super);

  function CopyToClipboard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.copy = function (content) {
      _this.setState({
        copied: true
      }, function () {
        copyToClipboard(content);
        typeof _this.props.copiedCallback === 'function' && _this.props.copiedCallback();
      });
    };

    _this.turnOffCopied = function () {
      _this.setState({
        copied: false
      });
    };

    _this.state = {
      copied: false,
      copy: _this.copy,
      turnOffCopied: _this.turnOffCopied
    };
    return _this;
  }

  CopyToClipboard.prototype.render = function () {
    if (typeof this.props.children !== 'function') {
      console.error('Children for <CopyToClipboard> must be a function which returns a JSX element!');
      return null;
    }

    return this.props.children(this.state);
  };

  return CopyToClipboard;
}(Component);

function useCopyToClipboard(copiedCallback) {
  var _a = useState(false),
      copied = _a[0],
      setCopied = _a[1];

  return {
    copy: function copy(content) {
      setCopied(true);
      copyToClipboard(content);
      typeof copiedCallback === 'function' && copiedCallback(content);
    },
    copied: copied,
    turnOffCopied: function turnOffCopied() {
      setCopied(false);
    }
  };
}

export default CopyToClipboard;
export { useCopyToClipboard };